import { withFieldHint } from "@/src/components/HighOrderComponents";
import { RatingField } from "@/src/components/Fields/RatingField";
import { useFormContext } from "react-hook-form";

const RatingFieldWithHint = withFieldHint(RatingField);

export function RatingInput(props: any) {
  const { hint, name } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const { control } = form;
  if (!name) return null;
  return (
    <RatingFieldWithHint
      {...props}
      control={control}
      name={name}
      hints={hints}
    />
  );
}
